<template>
  <v-autocomplete
    ref="autocomplete"
    v-model="internalValue"
    :items="items"
    :loading="loading"
    :menu-props="menuProps"
    :search-input.sync="searchQuery"
    v-bind="autocompleteProps"
    v-on="$listeners"
    @keydown.native.enter="_ => onLoadMore()"
    @keydown="isUserInput = true"
  >
    <template #append-item>
      <v-list-item v-if="!loading">
        <v-list-item-content>
          <v-list-item-title>
            <v-divider />
            <v-btn
              block
              color="primary"
              text
              :disabled="loadMoreDisabled"
              @click="_ => onLoadMore()"
            >
              {{ autocompleteButtonText }}
            </v-btn>
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item v-else>
        <v-list-item-content>
          <v-list-item-title>
            <v-progress-linear
              indeterminate
              color="primary"
            />
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </template>
  </v-autocomplete>
</template>

<script>
import { mapActions } from 'vuex'

import { SHARED_NAMESPACE } from '@/store/shared'

export default {
  name: 'DynamicAutoComplete',
  inheritAttrs: false,

  props: {
    fetchUrl: {
      type: String,
      required: true,
    },

    menuProps: {
      type: Object,

      default: _ => ({
        maxHeight: '300',
      }),
    },

    // eslint-disable-next-line vue/no-unused-properties
    selectedObject: {
      type: Object,
      default: _ => ({}),
    },

    sortBy: {
      type: Array,
      default: _ => ['name'],
    },

    value: {
      type: [String, Number],
      default: '',
    },

  },

  data () {
    return {
      isUserInput: false,
      items: [],

      loading: false,

      objUpdated: false,

      paginator: {
        last_page: false,
        page: 1,
      },

      paginatorOptions: {
        itemsPerPage: 10,
        page: 1,
        sortBy: this.sortBy,
        sortDesc: [true],
      },

      searchQuery: '',
    }
  },

  computed: {
    autocompleteButtonText () {
      if (this.searchQuery && this.isUserInput) {
        return `Search for "${this.searchQuery}"`
      }

      return this.noMoreItems ? 'No more items' : 'Load more'
    },

    autocompleteProps () {
      // Exclude props that are specific to InfiniteAutocomplete
      const {
        fetchUrl,
        menuProps,
        ...otherProps
      } = this.$attrs

      return otherProps
    },

    internalValue: {
      get () {
        return this.value
      },

      set (value) {
        this.$emit('input', value)
      },
    },

    loadMoreDisabled () {
      return this.noMoreItems && !this.isUserInput
    },

    noMoreItems () {
      return this.paginator.last_page
    },
  },

  watch: {
    internalValue (newValue) {
      if (newValue) {
        this.updateSelectedObject()
      }
    },

    items () {
      this.updateSelectedObject()
    },
  },

  mounted () {
    this.loadItems()
  },

  methods: {

    loadItems () {
      if (this.loading) return
      this.loading = true

      this.scrollableDropdownSearch({
        include: this.internalValue,
        paginatorOptions: this.paginatorOptions,
        path: this.fetchUrl,
        searchTerm: this.searchQuery,
      }).
        then(({ table, paginator }) => {
          this.items = [...this.items, ...table]
          this.paginator = paginator
        }).
        finally(_ => {
          this.loading = false
          this.isUserInput = false
        })
    },

    onLoadMore () {
      if (this.isUserInput) this.paginatorOptions.page = 1
      else this.paginatorOptions.page += 1

      this.loadItems()
    },

    updateSelectedObject () {
      this.objUpdated = true

      const obj = this.items.find(item => item.id === this.internalValue)
      this.$emit('update:selectedObject', obj)
    },

    ...mapActions(SHARED_NAMESPACE, [
      'scrollableDropdownSearch',
    ]),
  },

}
</script>
